/*
 * MoMuse custom JS
 * Loaded from layout/theme.liquid via assets/custom.js | asset_url.
 */

(function () {
  'use strict';

  /* ===========================================================
   * Product page: move the Effective Apps gift bag checkbox AND
   * the Swym wishlist button bar into the .momuse-secondary-row
   * placeholder above the Add to Cart button.
   *
   * Both are injected asynchronously by third-party app scripts.
   * We move:
   *   - The gift bag's outer wrapper (anchored by the stable
   *     #effectiveAppsEGWATC checkbox id)
   *   - The Swym .swym-wishlist-button-bar wrapper (the OUTER
   *     bar Swym injects, not just the inner button — moving the
   *     bar removes the empty original slot too)
   * Watch for mutations until both are relocated, then disconnect.
   * ========================================================= */

  function momuseMoveSecondaryActions() {
    var placeholder = document.querySelector('[data-momuse-secondary]');
    if (!placeholder) return false;

    var movedGiftBag = placeholder.querySelector('[data-momuse-gift-bag]');
    var movedWishlist = placeholder.querySelector('[data-momuse-wishlist]');

    // 1. Gift bag (Effective Apps) — anchored by stable checkbox id
    if (!movedGiftBag) {
      var giftCheckbox = document.getElementById('effectiveAppsEGWATC');
      if (giftCheckbox) {
        var giftLabel = giftCheckbox.closest('label');
        var giftWrap = giftLabel ? (giftLabel.parentElement || giftLabel) : giftCheckbox.parentElement;
        if (giftWrap && !placeholder.contains(giftWrap)) {
          giftWrap.setAttribute('data-momuse-gift-bag', '');
          placeholder.appendChild(giftWrap);
          movedGiftBag = giftWrap;
          // Fade in on next frame so the transition fires
          requestAnimationFrame(function () { giftWrap.classList.add('is-visible'); });
        }
      }
    }

    // 2. Swym wishlist button bar — move the OUTER wrapper, which
    //    removes the empty original slot below Add to Cart at the
    //    same time as relocating the inner button.
    if (!movedWishlist) {
      var swymBar = document.querySelector(
        '.swym-wishlist-button-bar:not([data-momuse-wishlist]), .swym-button-bar.swym-inject:not([data-momuse-wishlist])'
      );
      if (swymBar && !placeholder.contains(swymBar)) {
        swymBar.setAttribute('data-momuse-wishlist', '');
        placeholder.appendChild(swymBar);
        movedWishlist = swymBar;
        requestAnimationFrame(function () { swymBar.classList.add('is-visible'); });
      }
    }

    return Boolean(movedGiftBag) && Boolean(movedWishlist);
  }

  function initMomuseSecondaryActions() {
    // Only run on product pages
    if (!document.querySelector('[data-momuse-secondary]')) return;

    // First pass
    if (momuseMoveSecondaryActions()) return;

    // Watch for async injection from app scripts
    var observer = new MutationObserver(function () {
      if (momuseMoveSecondaryActions()) {
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Safety: stop observing after 15s even if one of the apps never loads
    setTimeout(function () {
      observer.disconnect();
    }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMomuseSecondaryActions);
  } else {
    initMomuseSecondaryActions();
  }

  /* ===========================================================
   * Header wishlist launcher
   * -----------------------------------------------------------
   * Header heart icon (sections/header.liquid) carries
   * `data-momuse-wishlist-launch`. Clicking it should open the
   * Swym Wishlist Plus drawer/page. Wishlist Plus loads
   * asynchronously via the app embed, so we use the official
   * SwymCallbacks queue to call swat.ui.openWishlist() once the
   * tracker is ready. The href #swym-wishlist is a no-op anchor
   * that prevents navigation if Swym never finishes loading.
   * ========================================================= */

  function momuseLaunchWishlist(event) {
    event.preventDefault();
    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(function (swat) {
      try {
        if (swat && swat.ui && typeof swat.ui.openWishlist === 'function') {
          swat.ui.openWishlist();
        } else if (swat && swat.evt && typeof swat.evt.broadcast === 'function') {
          swat.evt.broadcast('swym-launch-wishlist');
        }
      } catch (err) {
        console.warn('momuseLaunchWishlist', err);
      }
    });
  }

  function initMomuseWishlistLauncher() {
    var triggers = document.querySelectorAll('[data-momuse-wishlist-launch]');
    for (var i = 0; i < triggers.length; i++) {
      triggers[i].addEventListener('click', momuseLaunchWishlist);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMomuseWishlistLauncher);
  } else {
    initMomuseWishlistLauncher();
  }
  /* ===========================================================
   * AMP Product Descriptions: remove the app's CSS reset
   * -----------------------------------------------------------
   * The AMP app injects a <style> block that resets all
   * properties on #apd-root, #apd-root * — including
   * border-width: medium which creates visible borders.
   * We can't override it cleanly with CSS specificity,
   * so we remove the offending <style> tag at runtime.
   * ========================================================= */
  function removeApdResetStyle() {
    var styles = document.querySelectorAll('style');
    styles.forEach(function (el) {
      var text = el.textContent || '';
      if (
        text.indexOf('#apd-root') !== -1 &&
        text.indexOf('border-width : medium') !== -1
      ) {
        el.remove();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeApdResetStyle);
  } else {
    removeApdResetStyle();
  }
})();
